import {
    Box,
    Checkbox,
    FormControlLabel,
    Paper,
    Typography,
} from '@mui/material';
import React from 'react';
import { useCookies } from "react-cookie";
import { JWT } from "../Auth";
import Button from "../basic/Button";
import { useLocalStorage } from "../hooks/UseLocalStorage";

// Manual Tests Page

const Test: React.FC = () => {

    const [callLocal, setCallLocal] = useLocalStorage("callLocal", false);

    const [cookies, ] = useCookies(['cognito']);

    const jwt = new JWT(cookies['cognito']);

    if (jwt && !jwt.isValid()) {
        // delete cookie if it is not valid
        document.cookie = "cognito=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }

    function doLocalLogin(): void {
        document.location = 'https://family-archive.auth.ca-central-1.amazoncognito.com/oauth2/authorize?client_id=6dvug1qs413v1c8d96f2i77nl0&response_type=token&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=http%3A%2F%2Flocalhost%3A3000';
    }

    return (
        <Box>
            <Typography variant="h3" component="h1" gutterBottom>
                Test Page
            </Typography>
            
            <Paper sx={{ p: 3, mb: 3 }}>
                <Typography variant="h6" gutterBottom>
                    Authentication Status
                </Typography>
                <Typography variant="body1" gutterBottom>
                    Version 2.0 - Welcome {jwt.getName()}
                </Typography>
                <Typography variant="body1" gutterBottom>
                    Your JWT is {jwt.isValid() ? "Valid" : "Invalid"}
                </Typography>
                <Button onClick={doLocalLogin}>Local Login</Button>
            </Paper>

            <Paper sx={{ p: 3 }}>
                <Typography variant="h6" gutterBottom>
                    Development Settings
                </Typography>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={callLocal}
                            onChange={() => setCallLocal(!callLocal)}
                        />
                    }
                    label="Call local server"
                />
            </Paper>
        </Box>
    );
}

export default Test;
